/**
 * The one place `ContextPane` joins its two sources of a thread's data —
 * see ContextPane.tsx's own header comment ("fix round 2", task-42) for the
 * full story of why this join exists at all: before it, the pane read
 * everything from its own `ops.thread()` fetch, keyed only on `activeId`, so
 * a store update from anywhere else (a modal's `upsertThread`, the SSE
 * `thread` event) never reached it.
 *
 * `ThreadDetail` is `ThreadSummary` plus five fields the summary does not
 * carry (packages/shared/src/types.ts): `msgs`, `closeNote`, `lastSyncedAt`,
 * `handOffDisclosure`, `siblings`. Every `ThreadSummary` field comes from
 * `storeSummary` — the console store, kept current by both `upsertThread`
 * and the stream — so it always wins when both sides have an opinion.
 * `storeSummary` structurally cannot carry the five extra fields (its type
 * is `ThreadSummary`, not `ThreadDetail`), so spreading it after `detail`
 * can only ever add or override `ThreadSummary` fields — `detail`'s own
 * `msgs`/`closeNote`/`lastSyncedAt`/`handOffDisclosure`/`siblings` pass
 * through untouched regardless of whether a live store entry exists.
 *
 * `detail` itself still comes from `ops.thread()` — nothing here fetches
 * anything or reaches into a store; it is a pure join, testable on its own
 * (see test/mergeDetail.test.ts) independent of whatever `ContextTab`
 * happens to render.
 */
import type { ThreadDetail, ThreadSummary } from '@communicator/shared'

export function mergeThreadDetail(detail: ThreadDetail | null, storeSummary: ThreadSummary | null): ThreadDetail | null {
  if (!detail) return null
  return { ...detail, ...(storeSummary ?? {}) }
}
